// extracted by mini-css-extract-plugin
module.exports = {"desktop-view":"_3k672","mobile-view":"WPyjP","three-story-view":"_2BBMQ","wrapper":"_2v5CL"};